var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1107,
    height: 257,
    viewBox: "0 0 1107 257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#3E8CA9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 51H34V119H0zM43 27H77V119H43zM140 61H174V119H140zM188 3H222V119H188zM222 209.332v9.667L192.857 248H188v-4.833l34-33.835zm0 19.335v9.666L212.286 248h-9.715L222 228.667zM222 190v9.666L188 233.5v-9.667L222 190zm0-19.333v9.666L212.286 190 188 214.167V204.5l14.571-14.5L222 170.667zm0-19.335v9.667L192.857 190H188v-4.833l34-33.835zM222 132v9.666L188 175.5v-9.667L222 132zm-9.715 0L188 156.167V146.5l14.571-14.5h9.714zM92 17H126V119H92z",
    transform: "translate(-40 -33) translate(40 36)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3E8CA9",
    strokeLinecap: "square",
    strokeWidth: 3,
    d: "M1.5 125.5L220.5 125.5",
    transform: "translate(-40 -33) translate(40 36)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3E8CA9",
    strokeLinecap: "square",
    strokeWidth: 9,
    d: "M261.5 2.413L261.5 248.587",
    transform: "translate(-40 -33) translate(40 36)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Moderat-Bold, Moderat",
    fontSize: 135,
    fontWeight: "bold",
    letterSpacing: 3.115,
    transform: "translate(-40 -33) translate(40 36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 315.704,
    y: 168
  }, "GROWEGY")), /*#__PURE__*/React.createElement("path", {
    d: "M82 195.332v9.667L62.906 224h-9.715L82 195.332zm0 19.335V224h-9.379L82 214.667zM82 176v9.666L48 219.5v-9.667L82 176zm0-19.333v9.666L72.286 176 48 200.167V190.5L62.571 176 82 156.667zm0-19.335v9.667L52.857 176H48v-4.833l34-33.835zM77.645 132L48 161.5v-9.667L67.931 132h9.714zm-19.429 0L48 142.167V132.5l.502-.5h9.714zM34 171v9.75l-9.714 9.75-9.466 9.5H5.106l9.465-9.5L34 171zm0 19.5v9.5h-9.465L34 190.5zm0-39v9.749L4.857 190.5H0v-4.875L34 151.5zm0-19.5v9.749L0 175.875v-9.75L34 132zm-9.715 0L0 156.375v-9.75L14.571 132h9.714z",
    transform: "translate(-40 -33) translate(40 36)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34 19.332v9.667L4.857 58H0v-4.833l34-33.835zm0 19.335v9.666L24.286 58H14.57L34 38.667zM34 0v9.666L0 43.5v-9.667L34 0zm-9.715 0L0 24.167V14.5L14.571 0h9.714z",
    transform: "translate(-40 -33) translate(40 36) translate(140 132)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126 200v9.749L101.839 234h-9.714L126 200zm0 19.5v9.75l-4.733 4.75h-9.714L126 219.5zm0-39v9.749l-34 34.126v-9.75l34-34.125zm0-19.5v9.75l-9.714 9.75L92 204.875v-9.75l14.571-14.625L126 161zm0-19.5v9.749L96.857 180.5H92v-4.875l34-34.125zm-.249-9.5L92 165.875v-9.75L116.037 132h9.714zm-19.429 0L92 146.375v-9.75L96.608 132h9.714z",
    transform: "translate(-40 -33) translate(40 36)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo-full.8bdee42c0e1c2f88ef6adcae5289c1a0.svg";
export { ForwardRef as ReactComponent };